import { useTranslation } from "react-i18next";
import { useConfirmationDialog } from "../../../components/Dialogs/confirmation-dialog";

interface HidePricesToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function HidePricesToggle({
  checked,
  onChange,
  disabled,
  className,
}: HidePricesToggleProps) {
  const { t } = useTranslation();
  const { component: confirmDialog, open: openConfirm } = useConfirmationDialog(
    t("customerCreate.hidePricesConfirm"),
    () => onChange(true),
  );

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      openConfirm();
    } else {
      onChange(false);
    }
  }

  return (
    <div className={className ?? "my-4 flex flex-col space-y-1 border-t pt-4"}>
      <label className="flex items-center space-x-2 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="h-4 w-4"
        />
        <span className="font-bold text-sm">
          {t("customerCreate.hidePricesLabel")}
        </span>
      </label>
      <p className="text-xs text-gray-500 ml-6">
        {t("customerCreate.hidePricesDescription")}
      </p>
      {confirmDialog}
    </div>
  );
}
